import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Reserve, ReserveStatus } from '@/features/reserve/models/reserve';
import { Be1Repository } from '@/core/repositories/be1/be1-repository';
import { Observable } from 'rxjs';
import { format } from 'date-fns';
import { map } from 'rxjs/operators';

export interface GetTransactionParam {
    from: Date;
    to: Date;
    dateField: string;
    statuses: ReserveStatus[];
    userIds: string[];
    courseIds: string[];
    gdInvoiceId?: string;
    code?: string;
}

export interface BookingRequest {
    userId: string;
    slotId: string;
    persons: number;
    carts: number;
    payment: string;
    voucherCode: string;
    channel: string;
    golferName?: string;
    golferMobile?: string;
    memberId?: string;
    memberName?: string;
    jaNumber?: string;
    couponIds?: string[];
}

@Injectable({
    providedIn: 'root'
})
export class ReserveRepository extends Be1Repository<Reserve> {
    constructor(http: HttpClient) {
        super(http, 'reserve');
    }

    searchTransaction(param: Partial<GetTransactionParam>): Observable<Reserve[]> {
        const params = {
            ...param,
            from: param.from ? format(param.from!, 'yyyy-MM-dd') : '',
            to: param.from ? format(param.to!, 'yyyy-MM-dd') : ''
        };

        if (!params.dateField) {
            console.error('(BE bug) dateField override to created');
            params.dateField = 'created';
        }

        // Bug dev not return array
        return this.http.get<any>(`${this.entityUrl}/transaction`, { params }).pipe(
            map((r) => {
                return r.success ? (r.model ?? []) : r; // Bug dev not return array; it return {success: true, model: []}
            })
        );
    }

    newBooking(model: BookingRequest, jaFiles: File[] = []): Observable<Reserve> {
        const form = new FormData();
        form.append('json', JSON.stringify(model));
        for (const file of jaFiles) {
            form.append('files', file);
        }
        return this.http.post<any>(`${this.entityUrl}/booking`, form).pipe(this.mapSingle());
    }
}
